// extracted by mini-css-extract-plugin
export default {"root":"TruncatedText_root__GvQI9","clamp":"TruncatedText_clamp__wr08L","link":"TruncatedText_link__jGytE","readMore":"TruncatedText_readMore__sIMST"};